import React from 'react';
import PropTypes from 'prop-types';
import ContainerBoxStyled from './styles/ContainerBoxStyled';

const Container = ({
  children,
  background,
  padding,
  boxShadow,
  display,
  overflow,
  borderRadius,
  borderTop,
  borderBottom,
  gap,
  margin,
}) => (
  <ContainerBoxStyled
    background={background}
    padding={padding}
    boxShadow={boxShadow}
    display={display}
    overflow={overflow}
    borderRadius={borderRadius}
    borderTop={borderTop}
    borderBottom={borderBottom}
    gap={gap}
    margin={margin}
  >
    {children}
  </ContainerBoxStyled>
);

Container.propTypes = {
  children: PropTypes.node.isRequired,
  background: PropTypes.string,
  padding: PropTypes.string,
  boxShadow: PropTypes.string,
  display: PropTypes.string,
  overflow: PropTypes.string,
  borderRadius: PropTypes.string,
  borderTop: PropTypes.string,
  borderBottom: PropTypes.string,
  gap: PropTypes.string,
  margin: PropTypes.string,
};

Container.defaultProps = {
  background: 'rgba(255, 255, 255, 0.95)',
  padding: '20px',
  boxShadow: '0px 9px 38px -6px rgba(0, 0, 0, 0.14)',
  display: 'flex',
  overflow: 'hidden',
  borderRadius: '10px',
  borderTop: 'none',
  borderBottom: 'none',
  gap: '0',
  margin: 'auto auto 20px auto',
};

export default Container;
